import React from 'react'
import { Skeleton, Stack } from "@chakra-ui/react"

export default function GallerySkeleton() {
    return (
    [1,2,3,4,5,6,].map(
        ()=>
        <Stack className="col-lg-3 col-md-6 col-sm-6"  m={4}>
        <Skeleton height="30vh" width="100%"  className="single-gallery-box"/>
        </Stack>
    )
    )
}
